import React from 'react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { AlertCircle, Info } from 'lucide-react';
export interface CalculatorResultProps {
  result: {
    prijs: number;
    totaal: number;
    maxAfspraken: number;
    overschreden: boolean;
    verwachteOmzet: number;
    roi: number;
  };
  afspraken: string;
  onRequestQuote: () => void;
}
const CalculatorResult: React.FC<CalculatorResultProps> = ({
  result,
  afspraken,
  onRequestQuote
}) => {
  return <div id="result-section" className="bg-white p-6 md:p-8 rounded-lg shadow-md border border-gray-200">
      <h3 className="font-semibold text-xl mb-4 text-gray-900">Jouw Prognose</h3>
      
      {/* Marktlogica waarschuwing */}
      {result.overschreden && <Alert variant="destructive" className="mb-4">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Let op: Marktlimiet overschreden</AlertTitle>
          <AlertDescription>
            Je gewenste aantal afspraken ({afspraken}) is hoger dan het realistisch potentieel van je markt ({result.maxAfspraken} per maand). Pas je target of doelgroep aan.
          </AlertDescription>
        </Alert>}
      
      <div className="grid gap-4 mb-6">
        <div className="flex justify-between items-center py-2 border-b border-gray-100">
          <span className="text-gray-600">Maximaal haalbare afspraken per maand:</span>
          <span className="font-bold text-lg">{result.maxAfspraken}</span>
        </div>
        <div className="flex justify-between items-center py-2 border-b border-gray-100">
          <span className="text-gray-600">Prijs per warme afspraak:</span>
          <span className="font-bold text-lg">€{result.prijs}</span>
        </div>
        <div className="flex justify-between items-center py-2 border-b border-gray-100">
          <span className="text-gray-600">Totale maandkost:</span>
          <span className="font-bold text-lg">€{result.totaal}</span>
        </div>
        
        <div className="flex justify-between items-center py-2 border-b border-gray-100">
          <span className="text-gray-600">Verwachte maandomzet:</span>
          <span className="font-bold text-lg">€{result.verwachteOmzet}</span>
        </div>
        <div className="flex justify-between items-center py-2">
          <span className="text-gray-600">Geschatte rendabiliteit:</span>
          <span className="font-bold text-xl text-gray-900 flex items-center">
            {result.roi}% ROI
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="ml-1 cursor-help">
                  <Info className="h-4 w-4 text-gray-400" />
                </span>
              </TooltipTrigger>
              <TooltipContent className="max-w-xs text-sm text-gray-600">
                Wij adviseren steeds een minimum van 3X (300%) als ROI voor een rendabele campagne.
              </TooltipContent>
            </Tooltip>
          </span>
        </div>
        <p className="text-sm text-gray-500 mt-1">
          {result.roi}% wil zeggen dat voor elke euro die je investeert, je er {(result.roi / 100).toFixed(1)} terug krijgt.
        </p>
      </div>
      
      <p className="text-gray-600 mb-6">
        Op basis van jouw input kunnen wij jouw verwachte kost per warme afspraak optimaliseren.
      </p>
      
      <Button onClick={onRequestQuote} scrollToId="contact-form-section" className="btn-primary w-full flex items-center justify-center">
        Vraag direct een accurate offerte aan
      </Button>
    </div>;
};
export default CalculatorResult;